import { playerActivationStore } from "../../utils/firebase";
import { useAnalytics } from "../hooks/useAnalytics";
import { defineButton, DynamicBigButton } from "./DynamicBigButton";
import { openUrl } from "./openUrl";

export type BigButtonsProps = {
	buttons: ReturnType<typeof defineButton>[];
	suffix?: React.ReactNode;
};
export function BigButtons(props: BigButtonsProps) {
	const analytics = useAnalytics();
	
	return (
		<div className="flex flex-wrap w-full justify-center">
			{props.buttons.map((button) => {

				const onClick = () => {
					analytics.click(
						playerActivationStore.activationPassword!,
						button.label,
					);
					if (button.href) {
						openUrl(button.href);
						return;
					}
					if (button.onClick) button.onClick();
				}

				return (
					<DynamicBigButton
						key={button.label}
						label={button.label}
						backgroundUrl={button.backgroundUrl}
						onClick={onClick}
						href={button.href}
						target={button.target}
						navigateTo={button.navigateTo}
					/>
				);
			})}
			{props.suffix}
		</div>
	);
}
